function renderConfirmEmailInput (country, field) {
  let supportEmail = (country.is_PH) ? (fields_json.params.for_fields.confirm_email.support_email.split("@")[0] + '@' + window.location.hostname) : fields_json.params.for_fields.confirm_email.support_email
  let spamNotify = `<p style="margin-top:20px">${fields_json.params.for_fields.confirm_email.text_2[0]}<b>${fields_json.params.for_fields.confirm_email.text_2[1]}</b>${fields_json.params.for_fields.confirm_email.text_2[2]}<b>${fields_json.params.for_fields.confirm_email.text_2[3]}</b>${fields_json.params.for_fields.confirm_email.text_2[4]}
      <a href="mailto:${supportEmail}?subject=${fields_json.params.for_fields.confirm_email.subject}">${supportEmail}</a>.
    </p>`
  if (country.is_MX) {
    spamNotify = `<p style="border: 1px solid lightgray; padding: 5px; background: lightyellow;">${fields_json.params.for_fields.confirm_email.text_2[0]}<b>${fields_json.params.for_fields.confirm_email.text_2[1]}</b>${fields_json.params.for_fields.confirm_email.text_2[2]}<b>${fields_json.params.for_fields.confirm_email.text_2[3]}</b>
      <span class="to_spam_link hidden">(<b><a href="https://mail.google.com/mail/u/0/#spam" target="_blank" style="color: #ff1b53">¡HAZ CLIC AQUÍ!</a></b>)</span>
    </p>`
  }
  return `<div class="form-group ui-form__row ${field.hidden ? 'hidden' : ''} columnfield_">
    <div class="confirmpage-content">
      <p style="margin: 0px">${fields_json.params.for_fields.confirm_email.text_1[0]}<b id="email-copy"></b>${fields_json.params.for_fields.confirm_email.text_1[1]}<a href="/reg">${fields_json.params.for_fields.confirm_email.text_1[2]}</a>.</p>
      ${country.is_MX ? spamNotify : ''}
      <div>
        <div class="ui-form__field">
          <div class="ui-dropdown-field">
            <div class="ui-input ui-dropdown-field__active ui-input_fade">
              <label class="ui-input__container">
                <div class="ui-input__column">
                  <input type="${field.type}" name="${field.name}" value="${field.value ? field.value : ''}" autocomplete="new-password" autocapitalize="sentences" placeholder="${field.placeholder}" data-hj-whitelist class="ui-input__field ${field.value ? 'ui-input__field_not-empty' : ''}" data-required ${field.disabled ? 'disabled=""' : ''}>
                  <span class="ui-input__label ui-input__label_mark_required">
                    <span class="ui-input__label_placeholder-text">${field.label}</span>
                    <span class="ui-input__label_placeholder-hint"></span>
                  </span>
                </div>
                <div class="ui-input__additional"></div>
              </label>
            </div>
          </div>
          <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">${field.error}</div>
        </div>
      </div>
      ${country.is_MX ? '' : spamNotify}
    </div>
    <div class="modal-footer text-left" style="padding: 15px 0px">
      <div class="text-left">
        <a id="has_declined_confirm_email" style="cursor: pointer">${fields_json.params.for_fields.confirm_email.text_3[0]}</a>${fields_json.params.for_fields.confirm_email.text_3[1]}</div>
      </div>
    </div>`
}

export { renderConfirmEmailInput }